/* Maven hero ZIP checker — hand-written Lane B, NOT generated.

   Progressive enhancement over a real GET form. With this script absent,
   broken, or blocked, the form submits to the delivery-area page and the
   customer still gets their answer. That is the design, not a fallback bolted
   on afterwards: a control that says "checking…" and then does nothing is worse
   than a link.

   ⚠️ THIS FILE MUST NOT TOUCH THE CART. Not the Kumquat cart client, not the
   six DOM selectors it drives, not window.Kumquat. The lookup is a read against
   an App Proxy endpoint that has no path to an order, and the storefront's
   standing constraint is to stop and ask before going near the ordering flow.
   If a future change here needs the cart, it is the wrong change.

   The endpoint is Shopify's App Proxy, so Shopify signs the request on the way
   through and this file holds no secret. See kumquat_v2
   app/routes/apps.kumquat.zip-lookup.tsx. */
(function () {
  'use strict';

  /* Same shape the server enforces. Validating here too is not trust — the
     server re-checks — it is about not spending a round trip, and not making
     the customer wait to be told they typed four digits. */
  var ZIP = /^(\d{5})(?:-\d{4})?$/;

  /* Long enough to cover a cold proxy hop, short enough that a hung request
     becomes the link rather than a spinner nobody escapes. */
  var TIMEOUT_MS = 6000;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function setup(form) {
    /* Bind once. The script is loaded by whichever section renders a checker,
       so a page carrying both the hero and a content-page zip block gets two
       copies of this file — same URL, fetched once, executed twice. Without
       this guard that is two submit listeners on every form and two lookups
       per press. */
    if (form.getAttribute('data-maven-zip-bound')) return;
    form.setAttribute('data-maven-zip-bound', '1');

    var input = form.querySelector('.mv-zip__input');
    var button = form.querySelector('.mv-zip__go');
    var answer = form.parentNode.querySelector('[data-maven-zip-answer]');
    var endpoint = form.getAttribute('data-endpoint');
    var fallback = form.getAttribute('data-fallback') || '';
    if (!input || !answer || !endpoint) return;

    var inFlight = null;

    /* textContent everywhere. The body is JSON from our own endpoint, but the
       rule is the rule: nothing this page did not author becomes markup. */
    function say(text, tone) {
      answer.textContent = text;
      answer.setAttribute('data-tone', tone || '');
    }

    /* An answer the customer can act on. The link is appended as a real
       element, never as an HTML string. */
    function sayWithLink(text, tone, label) {
      say(text, tone);
      if (!fallback || !label) return;
      answer.appendChild(document.createTextNode(' '));
      var a = document.createElement('a');
      a.href = fallback;
      a.textContent = label;
      answer.appendChild(a);
    }

    function busy(on) {
      form.setAttribute('aria-busy', on ? 'true' : 'false');
      if (button) button.disabled = on;
    }

    form.addEventListener('submit', function (event) {
      var raw = (input.value || '').trim();
      var match = ZIP.exec(raw);

      if (!match) {
        /* Do NOT preventDefault into a dead end and do not submit junk either.
           Correct the customer and let them try again. */
        event.preventDefault();
        say('Enter a 5-digit ZIP code.', 'no');
        input.focus();
        return;
      }

      /* Only now do we take over the submit. Everything above this line still
         works with the form's own behaviour if the fetch path is unavailable. */
      if (typeof window.fetch !== 'function' || typeof window.AbortController !== 'function') {
        return; /* let the browser submit to the delivery page */
      }
      event.preventDefault();

      var zip = match[1];
      if (inFlight) inFlight.abort();
      var controller = new AbortController();
      inFlight = controller;
      /* A timeout and a supersede are both AbortError. Told apart, because one
         must leave "Checking…" on screen replaced by something and the other
         must not touch it — the next request owns the answer. Without this
         flag a hung request leaves a spinner nobody escapes, which is the
         thing this control exists not to be. */
      var timedOut = false;
      var timer = setTimeout(function () {
        timedOut = true;
        controller.abort();
      }, TIMEOUT_MS);

      busy(true);
      say('Checking…', '');

      fetch(endpoint + '?zip=' + encodeURIComponent(zip), {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        signal: controller.signal
      })
        .then(function (res) {
          /* A 404 here means the Kumquat app is not installed on this store.
             That is a deployment fact, not a delivery answer. */
          if (!res.ok) throw new Error('http ' + res.status);
          return res.json();
        })
        .then(function (data) {
          if (!data || data.status !== 'ok') throw new Error('unusable body');
          if (data.deliverable) {
            sayWithLink(
              'Yes — we deliver to ' + data.zip + ' on ' + data.day + '.',
              'yes', 'See the delivery area'
            );
          } else {
            /* Never "no". The zone list is not the whole story — catering and
               shipping reach further — and the delivery page is where that is
               explained. */
            sayWithLink(
              'We do not have a delivery route to ' + data.zip + ' yet.',
              'none', 'See where we deliver'
            );
          }
        })
        .catch(function (err) {
          /* Superseded by a newer lookup: the newer one owns the answer. */
          if (err && err.name === 'AbortError' && !timedOut) return;
          /* Say nothing about deliverability. An outage must not read as "no",
             so the tone is neutral and the wording is about us, not the ZIP. */
          sayWithLink('We could not check just now.', '', 'See where we deliver');
        })
        .finally(function () {
          clearTimeout(timer);
          if (inFlight === controller) inFlight = null;
          busy(false);
        });
    });

    /* Clear a stale answer as soon as the ZIP changes, so the previous
       result cannot be read as the answer to the new one. */
    input.addEventListener('input', function () {
      if (answer.textContent) say('', '');
    });
  }

  ready(function () {
    var forms = document.querySelectorAll('[data-maven-zip]');
    for (var i = 0; i < forms.length; i++) setup(forms[i]);
  });
})();
